import { PossibleStatisticCategories, statisticCategories } from '@/resources/constantsStatistic';

const checkStatisticCategory = (key: string): key is PossibleStatisticCategories =>
  statisticCategories.findIndex((a) => a === key) !== -1;

export default checkStatisticCategory;
